export default [
  {
    headerName: '',
    width: 30,
    field: 'rowIndex',
    hidden: true,
    suppressMovable: true,
    cellStyle: {
      textAlign: 'center',
      padding: '5px 0',
      color: '#595959',
      backgroundColor: '#f0f0f0',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: '500',
      boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
    },
  },
  // {
  //   headerName: '学员账号',
  //   field: 'account',
  //   width: 20,
  //   cellStyle: {
  //     textAlign: 'center',
  //   },
  //   style: {
  //     alignment: {vertical: 'bottom', horizontal: 'left'},
  //   },
  // },
]
